import React, { Component } from 'react'
import { Row, Col, Alert, Button, Table, Checkbox, Radio, Input } from 'antd'
import moment from 'moment'
const { TextArea } = Input
const RadioGroup = Radio.Group;

const dateFormat = 'YYYY/MM/DD HH:mm'

const radioStyle = {
    display: 'block',
    height: '30px',
    lineHeight: '30px',
};

class SimpleIssueStep4 extends Component {

    constructor(props) {
        super(props)
        this.submitReady = this.submitReady.bind(this)
    }

    submitReady() {
        let result = true;
        let data = this.props;
        if (!data.issue_type) {
            result = false
        }
        if (data.freguesia.length === 0) {
            result = false
        }
        if (
            (typeof data.mapCenter === 'undefined') || (data.mapCenter === null)
            || (typeof data.mapCenter[0] === 'undefined') || (data.mapCenter[0] === null)
            || (typeof data.mapCenter[1] === 'undefined') || (data.mapCenter[1] === null)
        ) {
            result = false
        }
        if (!data.issue_date) {
            result = false;
        }
        if (!data.obs && !data.newAttach.length) {
            result = false;
        }
        if (!data.privacy_accepted) {
            result = false;
        }
        return result;
    }

    render() {

        // New attachments
        var attachments = []
        const newAttachColumns = [
        {
            title: 'Tipo',
            dataIndex: 'description',
            key: 'description'
        },
        {
            title: 'Nome',
            dataIndex: 'name',
            key: 'name'
        }]
        attachments = this.props.newAttach.map((item) => {
            item.key = item.uid
            return item
        })
        this.props.attachments.forEach((item) => {
            item.key = item.id
            item.name = item.descricao
            item.description = item.tipo_ficheiro_id === 1 ? 'Fotografia'
                : (item.tipo_ficheiro_id === 2 ? 'Levantamento topográfico' : 'Outro')
            attachments.push(item)
        })
        let programa_titulo = 'Não aplicável';
        let programs = this.props.programs || [];
        let choosen_program = programs.filter(p => ''+p.id === this.props.programa_id)
        if (choosen_program.length) programa_titulo = choosen_program[0].titulo;
        
        // Fontes que necessitam de especificação
        const fonte_trigger = ['Sim enquanto autor', 'É de terceiros ou autor desconhecido'];
        return (
            <div className={this.props.className}>

                <Row>
                    <Col xs={24} sm={6}></Col>
                    <Col xs={24} sm={14}><legend>Prévisualizar Submissão</legend></Col>
                </Row>

                <Row>
                    <Col xs={24} sm={6}></Col>
                    <Col xs={24} sm={14}>

                        <table style={{textAlign: 'left', verticalAlign: 'top'}}>
                            <tbody>
                                <tr>
                                    <th>Programa</th><td>{programa_titulo}</td>
                                </tr>
                                <tr>
                                    <th>Local</th><td>{this.props.address || <em>Por definir</em>}</td>
                                </tr>
                                <tr>
                                    <th>Freguesia</th><td>{this.props.freguesia || 'Por definir'}</td>
                                </tr>
                                <tr>
                                    <th>Concelho</th><td>{this.props.concelho || 'Por definir'}</td>
                                </tr>
                                <tr>
                                    <th>Distrito</th><td>{this.props.distrito || 'Por definir'}</td>
                                </tr>
                                <tr>
                                    <th>ARH</th><td>{this.props.arh || 'Por definir'}</td>
                                </tr>
                                <tr>
                                    <th>Data da Ocorrência</th>
                                    { this.props.data_ocorrencia_tipo === 0 ? (
                                      <td>{moment(this.props.issue_date + ' ' + this.props.issue_time, 'YYYY/MM/DD HH:mm').format(dateFormat)}</td>
                                    ) : (
                                        <td><em>Indeterminada</em></td>
                                    )}
                                </tr>

                                { this.props.user.indexOf('public_') === -1 ? (
                                    <tr>
                                        <th>E-mail</th><td>{this.props.user}</td>
                                    </tr>
                                ) : (
                                    <tr>
                                        <th>E-mail</th><td>{this.props.email || 'Por definir'}</td>
                                    </tr>
                                )}

                                { this.props.obs ? (
                                    <tr>
                                        <th>Observações</th>
                                        <td>{this.props.obs}</td>
                                    </tr>
                                ) : null }

                            </tbody>
                        </table>

                        <legend style={{marginTop: '20px'}}>Anexos</legend>
                        <Table dataSource={attachments} columns={newAttachColumns} />

                        <legend style={{marginTop: '20px'}}>Fonte de Dados</legend>
                        <div className="ant-row ant-form-item">
                            <div className="ant-form-item-control-wrapper ant-col-xs-24 ant-col-sm-24">
                                <p>Concorda com a publicitação dos dados a submeter?</p>
                                <RadioGroup 
                                    onChange={(e) => this.props.onChangeField('fonte_tipo', e.target.value)}
                                    value={this.props.fonte_tipo}>
                                    { this.props.data_source_options.map(opt => (
                                        <Radio style={radioStyle} value={opt}>{opt}</Radio>    
                                    ))}
                                </RadioGroup>
                            </div>
                        </div>

                        { fonte_trigger.indexOf(this.props.fonte_tipo) > -1 && (
                            <div className="ant-row ant-form-item">
                                <div className="ant-form-item-control-wrapper ant-col-xs-24 ant-col-sm-24">
                                    <div className="ant-form-item-control">
                                        <TextArea id="fonte_texto" rows={2} value={this.props.fonte_texto}
                                            placeholder="Especifique a fonte"
                                            onChange={(e) => this.props.onChangeField('fonte_texto', e.target.value)} />
                                    </div>
                                </div>
                            </div>
                        )}

                        <legend style={{marginTop: '20px'}}>Politica de Privacidade</legend>
                        <div className="ant-row ant-form-item">
                            <div className="ant-form-item-control-wrapper ant-col-xs-24 ant-col-sm-14">
                                <Checkbox
                                    checked={!!this.props.privacy_accepted}
                                    onChange={(e) => this.props.onChangeField('privacy_accepted', e.target.checked ? 1 : 0)}
                                    >
                                    Aceito os termos da
                                </Checkbox>
                                <a onClick={this.props.showModal}>Política de Privacidade</a>
                            </div>
                        </div>

                        <div style={{borderTop: '2px solid gray', marginTop: '16px', paddingTop: '8px'}}>
                            <Button type="danger" onClick={(e) => this.props.history.push('/')}>
                                <span className="hide-small">Cancelar</span>
                                <i className="anticon anticon-close"></i>
                            </Button>
                            {' '}
                            { this.props.status !== 'Submetida' ? (
                                <Button style={{float: 'right'}} type="primary"
                                    disabled={!this.submitReady()}
                                    onClick={(e) => this.props.onSubmit()}>
                                    Submeter
                                    <i className="anticon anticon-right"></i>
                                </Button>
                            ) : null }
                        </div>

                        <Alert style={{display: this.props.complete && !this.props.error ? 'block' : 'none', marginTop: '20px' }}
                            message="Sucesso!"
                            description={'A ocorrência foi guardada.' + (this.props.status !== 'Submetida' ? ' Para enviar definitivamente clique em Submeter.' : '')}
                            type="success"
                            showIcon
                        />

                        <Alert style={{display: this.props.complete && this.props.error ? 'block' : 'none', marginTop: '20px' }}
                            message="Erro"
                            description={'Ocorreu um erro ao registar a ocorrência: ' + this.props.error}
                            type="error"
                            showIcon
                        />

                    </Col>
                </Row>

            </div>
        )
    }
}

export default SimpleIssueStep4;



// WEBPACK FOOTER //
// ./src/components/SimpleIssueStep4.js